export default "__VITE_ASSET__JHMrjGcO__"